(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      const closeButton = this.querySelector('.announcement__close');
      const ad = window.sessionStorage.getItem('announcementDismissed');

      if (!ad) {
        this.classList.remove('hide');
      }

      if (closeButton) {
        closeButton.addEventListener('click', this.hideAnnouncement.bind(this));
      }
    }

    hideAnnouncement() {
      window.sessionStorage.setItem('announcementDismissed', true);
      this.classList.add('announcement-bar--hide');

      setTimeout(() => {
        this.style.display = 'none';
      }, 300);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    class SignupBanner extends HTMLElement {
      constructor() {
        super();

        this.signupForm = this.querySelector('.newsletter-form');

        if (this.signupForm) {
          this.submitButton = this.signupForm.querySelector('button[type="submit"]');

          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }

          clearInputErrors(this.signupForm);

          this.signupForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      handleSubmit(evt) {
        const formIsValid = validateForm(this.signupForm);

        if (formIsValid) {
          if (this.submitButton) {
            this.submitButton.classList.add('btn--loading');
          }
        } else {
          evt.preventDefault();
        }
      }
    }

    customElements.define('signup-banner', SignupBanner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-linked-menu"]) return;
  try {
    
  class FaqLinkedMenu extends HTMLElement {
    constructor() {
      super();
      this.faqLinkedMenuContent = this.querySelector('.faq-linked-menu-content');
      this.accordionComponent = document.querySelectorAll('.faq-item');
      const faqlinkedItems = [];

      this.accordionComponent.forEach((elm, i) => {
        if (i != 0) {
          elm.classList.add('hide');
        }

        const faqLinkedMenuSection = elm.querySelector('[data-menu-info="faq-linked-menu"]');

        if (faqLinkedMenuSection) {
          const newMenuItem = document.createElement('li');
          newMenuItem.dataset.linkType = elm.dataset.sectionType;
          newMenuItem.innerHTML = faqLinkedMenuSection.innerHTML;

          if (i === 0) {
            newMenuItem.classList.add('active');
          }

          this.faqLinkedMenuContent.appendChild(newMenuItem);

          newMenuItem.addEventListener('click', this.handleClick.bind(this));
        }

        faqLinkedMenuSection.classList.add('hide');
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const contentId = target.dataset.linkType;

      const activeElement = document.querySelector(`[data-section-type=${contentId}]`);
      const activeHeaderItem = this.faqLinkedMenuContent.querySelector('li.active');

      if (activeHeaderItem !== target) {
        activeHeaderItem.classList.remove('active');
        target.classList.add('active');
      }

      this.accordionComponent.forEach((elm) => {
        if (!elm.classList.contains('hide')) {
          elm.classList.add('collapsible-content--hide');
          setTimeout(function () {
            elm.classList.add('hide');
          }, 200);
        }
      });

      setTimeout(function () {
        activeElement.classList.remove('hide');
        activeElement.classList.remove('collapsible-content--hide');
      }, 200);
    }
  }

  customElements.define('faq-linked-menu', FaqLinkedMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.background = this.getAttribute('data-background');
      this.applyColorScheme = this.getAttribute('data-color-scheme');
      this.headerBounds = {};
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.headerSearch = this.querySelector('.header__search');

      this.headerHeight = this.header.getBoundingClientRect().height;
      this.headerWrap = this.header.querySelector('.header-wrapper');
      this.isFrosted = this.headerWrap.dataset.frosted;
      this.isSticky = this.headerWrap.dataset.sticky;
      // Reuse the proven smooth mobile overlay and return state on every sticky storefront header.
      this.isMobileHomeHeader = Boolean(this.isSticky);
      this.mobileHomeHeaderMedia = window.matchMedia('(max-width: 749px)');
      this.mobileHomeHeaderHeight = this.headerHeight;
      this.mobileHomeHeaderTop = this.header.getBoundingClientRect().top + window.scrollY;
      this.mobileHomeHeaderCompactHeight = null;
      this.mobileHomeHeaderExpandedLogoWidth = null;
      this.mobileHomeHeaderExpandedLogoHeight = null;
      this.mobileHomeHeaderCompactLogoWidth = null;
      this.mobileHomeHeaderCompactLogoHeight = null;
      this.mobileHomeHeaderSpacer = null;
      this.menuInline = this.header.querySelector('.list-menu--inline');
      this.activeMenuItem = this.header.querySelector('.header__active-menu-item');
      this.listMenuItems = this.header.querySelectorAll('.header__inline-menu .list-menu__item-list');

      this.openingMenu = false;
      this.closingMenu = false;
      this.isFadeOutTransition = false;

      if (this.isMobileHomeHeader) {
        const mobileHomeHeaderLogo = this.getMobileHomeHeaderVisibleLogo();
        if (mobileHomeHeaderLogo) {
          const mobileHomeHeaderLogoBounds = mobileHomeHeaderLogo.getBoundingClientRect();
          this.mobileHomeHeaderExpandedLogoWidth = mobileHomeHeaderLogoBounds.width;
          this.mobileHomeHeaderExpandedLogoHeight = mobileHomeHeaderLogoBounds.height;
        }

        this.mobileHomeHeaderSpacer = document.createElement('div');
        this.mobileHomeHeaderSpacer.className = 'sb-mobile-home-header-spacer';
        this.mobileHomeHeaderSpacer.setAttribute('aria-hidden', 'true');
        this.header.insertAdjacentElement('afterend', this.mobileHomeHeaderSpacer);
        this.onMobileHomeHeaderMediaChange = this.handleMobileHomeHeaderMediaChange.bind(this);
        this.mobileHomeHeaderMedia.addEventListener('change', this.onMobileHomeHeaderMediaChange);
      }

      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('mouseleave', this.handleMouseleave.bind(this)));
      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('click', this.handleClick.bind(this)));

      if (this.isSticky) {
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      const searchHomeField = document.getElementById('search-home-field');
      let headerHeight = this.header.getBoundingClientRect().height;
      if (searchHomeField) {
        headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
        if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
          searchHomeField.classList.add('search-home--transparent');
        }
      }
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      let prevHeight = 0;
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.contentBoxSize) {
            const height = entry.contentBoxSize?.[0].blockSize;
            if (typeof height === 'number' && height !== prevHeight) {
              prevHeight = height;
              const mobileHomeHeaderOverlayActive = this.isMobileHomeHeader
                && this.header.classList.contains('sb-mobile-home-header-fixed');

              if (!mobileHomeHeaderOverlayActive) {
                let headerHeight = this.header.getBoundingClientRect().height;
                if (searchHomeField) {
                  headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
                }
                document.documentElement.style.setProperty('--header-height', headerHeight + 'px');

                if (this.isMobileHomeHeader && !this.header.classList.contains('shopify-section-header-sticky')) {
                  const mobileHomeHeaderBounds = this.header.getBoundingClientRect();
                  this.mobileHomeHeaderHeight = mobileHomeHeaderBounds.height;
                  this.mobileHomeHeaderTop = mobileHomeHeaderBounds.top + window.scrollY;

                  const mobileHomeHeaderLogo = this.getMobileHomeHeaderVisibleLogo();
                  if (mobileHomeHeaderLogo) {
                    const mobileHomeHeaderLogoBounds = mobileHomeHeaderLogo.getBoundingClientRect();
                    this.mobileHomeHeaderExpandedLogoWidth = mobileHomeHeaderLogoBounds.width;
                    this.mobileHomeHeaderExpandedLogoHeight = mobileHomeHeaderLogoBounds.height;
                  }
                }
              }
            }
          }
        }
      });

      resizeObserver.observe(this.header);
      this.setupTransparency();
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:unload', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:reorder', this.setupTransparency.bind(this));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.isMobileHomeHeader) {
        this.mobileHomeHeaderMedia.removeEventListener('change', this.onMobileHomeHeaderMediaChange);
        this.deactivateMobileHomeHeaderOverlay();
        this.mobileHomeHeaderSpacer?.remove();
      }
    }

    handleMobileHomeHeaderMediaChange(event) {
      if (!event.matches) {
        this.deactivateMobileHomeHeaderOverlay();
      }
    }

    activateMobileHomeHeaderOverlay() {
      if (!this.isMobileHomeHeader || !this.mobileHomeHeaderMedia.matches || !this.mobileHomeHeaderSpacer) return;

      const mobileHomeHeaderNormalFlow = !this.header.classList.contains('shopify-section-header-sticky')
        && !this.header.classList.contains('sb-mobile-home-header-fixed');

      if (mobileHomeHeaderNormalFlow) {
        const mobileHomeHeaderBounds = this.header.getBoundingClientRect();
        this.mobileHomeHeaderHeight = mobileHomeHeaderBounds.height;
        this.mobileHomeHeaderTop = mobileHomeHeaderBounds.top + window.scrollY;

        const mobileHomeHeaderLogo = this.getMobileHomeHeaderVisibleLogo();
        if (mobileHomeHeaderLogo) {
          const mobileHomeHeaderLogoBounds = mobileHomeHeaderLogo.getBoundingClientRect();
          this.mobileHomeHeaderExpandedLogoWidth = mobileHomeHeaderLogoBounds.width;
          this.mobileHomeHeaderExpandedLogoHeight = mobileHomeHeaderLogoBounds.height;
        }
      }

      this.mobileHomeHeaderSpacer.style.height = `${this.mobileHomeHeaderHeight}px`;
      this.mobileHomeHeaderSpacer.classList.add('is-active');
      this.header.classList.add('sb-mobile-home-header-fixed');
    }

    getMobileHomeHeaderVisibleLogo() {
      const mobileHomeHeaderLogos = Array.from(this.header.querySelectorAll('.header__heading-logo'));
      return mobileHomeHeaderLogos.find((logo) => window.getComputedStyle(logo).visibility !== 'hidden')
        || mobileHomeHeaderLogos[0]
        || null;
    }

    clearMobileHomeHeaderReturnState() {
      this.header.classList.remove('sb-mobile-home-header-returning');
      this.header.style.removeProperty('--sb-mobile-home-header-return-height');
      this.header.style.removeProperty('--sb-mobile-home-header-return-logo-width');
      this.header.style.removeProperty('--sb-mobile-home-header-return-logo-height');
    }

    updateMobileHomeHeaderReturn(scrollTop) {
      if (
        !this.isMobileHomeHeader
        || !this.mobileHomeHeaderMedia.matches
        || !this.mobileHomeHeaderSpacer?.classList.contains('is-active')
        || !this.header.classList.contains('sb-mobile-home-header-fixed')
      ) {
        return false;
      }

      const expandedHeight = this.mobileHomeHeaderHeight;
      const headerTop = this.mobileHomeHeaderTop;

      if (scrollTop <= headerTop) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
        return true;
      }

      if (!this.mobileHomeHeaderCompactHeight || !this.header.classList.contains('sb-mobile-home-header-returning')) {
        const compactHeight = this.header.getBoundingClientRect().height;
        if (compactHeight > 0 && compactHeight < expandedHeight) {
          this.mobileHomeHeaderCompactHeight = compactHeight;

          const mobileHomeHeaderLogo = this.getMobileHomeHeaderVisibleLogo();
          if (mobileHomeHeaderLogo) {
            const mobileHomeHeaderLogoBounds = mobileHomeHeaderLogo.getBoundingClientRect();
            this.mobileHomeHeaderCompactLogoWidth = mobileHomeHeaderLogoBounds.width;
            this.mobileHomeHeaderCompactLogoHeight = mobileHomeHeaderLogoBounds.height;
          }
        }
      }

      const compactHeight = this.mobileHomeHeaderCompactHeight || 44;
      const returnDistance = Math.max(0, expandedHeight - compactHeight);
      const returnStart = headerTop + returnDistance;

      if (returnDistance < 0.5 || scrollTop > returnStart) {
        this.clearMobileHomeHeaderReturnState();
        return false;
      }

      const progress = Math.min(1, Math.max(0, (returnStart - scrollTop) / returnDistance));
      const returnHeight = compactHeight + (returnDistance * progress);

      this.header.classList.add('sb-mobile-home-header-returning');
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.style.setProperty('--sb-mobile-home-header-return-height', `${returnHeight}px`);

      if (
        this.mobileHomeHeaderExpandedLogoWidth
        && this.mobileHomeHeaderExpandedLogoHeight
        && this.mobileHomeHeaderCompactLogoWidth
        && this.mobileHomeHeaderCompactLogoHeight
      ) {
        const logoWidth = this.mobileHomeHeaderCompactLogoWidth
          + ((this.mobileHomeHeaderExpandedLogoWidth - this.mobileHomeHeaderCompactLogoWidth) * progress);
        const logoHeight = this.mobileHomeHeaderCompactLogoHeight
          + ((this.mobileHomeHeaderExpandedLogoHeight - this.mobileHomeHeaderCompactLogoHeight) * progress);

        this.header.style.setProperty('--sb-mobile-home-header-return-logo-width', `${logoWidth}px`);
        this.header.style.setProperty('--sb-mobile-home-header-return-logo-height', `${logoHeight}px`);
      }

      return true;
    }

    deactivateMobileHomeHeaderOverlay() {
      if (!this.mobileHomeHeaderSpacer) return;

      this.clearMobileHomeHeaderReturnState();
      this.header.classList.remove('sb-mobile-home-header-fixed');
      this.mobileHomeHeaderSpacer.classList.remove('is-active');
      this.mobileHomeHeaderSpacer.style.removeProperty('height');
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.headerSearch && this.headerSearch.isOpen()) return;

      if (this.updateMobileHomeHeaderReturn(scrollTop)) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.activateMobileHomeHeaderOverlay();
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.activateMobileHomeHeaderOverlay();
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
      this.deactivateMobileHomeHeaderOverlay();

      if (!this.applyColorScheme) {
        this.header.classList.remove(this.background);
      }
    }

    handleClick(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');

      this.header.classList.add(this.background, 'is-filled');

      if (detailsElement) {
        setTimeout(() => {
          detailsElement.classList.add('sub-menu-opening');
        });
      }
    }

    handleMouseEnter(event) {
      const menuItem = event.target;
      const menuItemSpan = menuItem.querySelector('.header__menu-item');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });
      menuItemSpan.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.closingMenu && detailsElement.getAttribute('open') && !this.isFadeOutTransition) {
        window.clearTimeout(this.timeoutClose);
        this.closingMenu = false;
      }

      if (detailsElement.getAttribute('open') && !this.isFadeOutTransition) return;

      window.clearTimeout(this.timeoutOpen);
      this.openingMenu = true;

      this.timeoutOpen = setTimeout(() => {
        this.openingMenu = false;
        this.openSubMenu(detailsElement);
      }, 300);
    }

    openSubMenu(detailsElement) {
      detailsElement.setAttribute('open', true);
      if (this.isFrosted) this.headerWrap.classList.remove('frosted-header-glass');
      this.header.classList.add(this.background, 'is-filled');
      this.closeMenuLocalization();
      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseleave(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });

      if (this.activeMenuItem) this.activeMenuItem.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.openingMenu && !detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutOpen);
        this.openingMenu = false;
      }

      if (!detailsElement.getAttribute('open')) return;

      this.closingMenu = true;
      this.timeoutClose = setTimeout(() => {
        this.closingMenu = false;
        this.closeSubMenu(detailsElement);
      }, 300);
    }

    closeSubMenu(detailsElement) {
      if (this.isFrosted) this.headerWrap.classList.add('frosted-header-glass');
      this.header.classList.remove('is-filled');
      if (!this.header.classList.contains('animate')) {
        this.header.classList.remove(this.background);
      }

      detailsElement.classList.remove('sub-menu-opening');
      this.isFadeOutTransition = true;

      detailsElement.addEventListener(
        'transitionend',
        () => {
          detailsElement.removeAttribute('open');
          this.isFadeOutTransition = false;
        },
        { once: true }
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeMenuLocalization() {
      this.headerLocalization = this.headerLocalization || this.header.querySelectorAll('localization-form');
      this.headerLocalization.forEach((disclosure) => disclosure.hidePanel());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        // this.searchModal.close(false);
      }
    }

    setupTransparency() {
      if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
        this.classList.add(this.background);
        this.setAttribute('data-transparency', true);
      } else {
        if (this.isSticky && !this.applyColorScheme) {
          this.classList.remove(this.background);
        }
        this.removeAttribute('data-transparency');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  class newsletterForm extends HTMLElement {
    constructor() {
      super();
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      const sectionId = this.dataset.sectionId;
      const contactNewsletter = this.querySelector(`#Contact_${sectionId}`);
      const inputEmailGroup = contactNewsletter.querySelector('.input-group');
      const inputEmailNewsletter = contactNewsletter.querySelector('input[type="email"]');
      const errorMessage = contactNewsletter.querySelector(`#Newsletter-error--${sectionId}`);
      const errorMessageText = errorMessage.querySelector('.input-error-message__text');
      const iconError = contactNewsletter.querySelector('.field-wrapper__icon-error');
      const existingEmailMsg = contactNewsletter.querySelector('.newsletter-email-exist');
      const urlUserCame = document.referrer ? new URL(document.referrer) : null;
      let fragmentTargetId = '';

      try {
        fragmentTargetId = decodeURIComponent(window.location.hash.slice(1));
      } catch (error) {
        fragmentTargetId = '';
      }

      inputEmailNewsletter.addEventListener('keyup', function (e) {
        if (e.code === 'Enter') return;
        inputEmailGroup.classList.remove('input-group--error');
        inputEmailNewsletter.classList.remove('input--error');
        inputEmailNewsletter.removeAttribute('aria-invalid');
        inputEmailNewsletter.removeAttribute('aria-describedby');
        inputEmailNewsletter.removeAttribute('data-form-status');
        errorMessage.classList.add('hide');
        errorMessage.classList.remove('hidden');
        errorMessage.hidden = false;
        iconError.classList.add('hide');
        if (existingEmailMsg) {
          existingEmailMsg.classList.add('hide');
          existingEmailMsg.classList.remove('hidden');
          existingEmailMsg.hidden = false;
        }
      });

      if (
        existingEmailMsg &&
        searchParams.has('form_type') &&
        inputEmailNewsletter.value &&
        fragmentTargetId === contactNewsletter.id
      ) {
        existingEmailMsg.hidden = false;
        existingEmailMsg.classList.remove('hidden');
        existingEmailMsg.classList.remove('hide');
      }

      if ( urlUserCame && urlUserCame.pathname === '/challenge' ) {
        document.querySelector(`#Contact_${sectionId}`).scrollIntoView();
      }

      contactNewsletter.addEventListener('submit', (event) => {
        const email = inputEmailNewsletter.value;

        if (!this.validateEmail(email)) {
          event.preventDefault();
          var erroMessage = '';

          if (email === '') {
            erroMessage = window.loginStrings.errorEmailRequired;
          } else {
            erroMessage = window.loginStrings.errorEmailInvalid;
          }

          inputEmailGroup.classList.add('input-group--error');
          inputEmailNewsletter.classList.add('input--error');
          inputEmailNewsletter.setAttribute('aria-invalid', 'true');
          inputEmailNewsletter.setAttribute('aria-describedby', `Newsletter-error--${sectionId}`);
          inputEmailNewsletter.setAttribute('data-form-status', 'true');

          if (errorMessageText) errorMessageText.textContent = erroMessage;
          errorMessage.hidden = false;
          errorMessage.classList.remove('hidden');
          errorMessage.classList.remove('hide');
          iconError.hidden = false;
          iconError.classList.remove('hidden');
          iconError.classList.remove('hide');
          inputEmailNewsletter.focus();
        }

        return false;
      });
    }

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  customElements.define('newsletter-form', newsletterForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silver-bullet-fitment-finder"] && !Shopify.designMode) return;
  try {
    
  const revealModelRequestFeedback = (root = document) => {
    const disclosures = root.querySelectorAll('[data-sb-model-request-disclosure]');

    disclosures.forEach((disclosure) => {
      const feedback = disclosure.querySelector('.sb-model-request__success, .sb-model-request .errors');

      if (!feedback) return;

      disclosure.open = true;
      feedback.setAttribute('tabindex', '-1');
      requestAnimationFrame(() => feedback.focus());
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => revealModelRequestFeedback());
  } else {
    revealModelRequestFeedback();
  }

  document.addEventListener('shopify:section:load', (event) => revealModelRequestFeedback(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silver-bullet-homepage-pro"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sb-hero-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-sb-hero-slide]'));
    const controls = Array.from(carousel.querySelectorAll('[data-sb-hero-control]'));
    const toggle = carousel.querySelector('[data-sb-hero-toggle]');
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const compactQuery = window.matchMedia('(max-width: 640px)');
    let activeIndex = 0;
    let timer;
    let userPaused = false;
    let hoverPaused = false;
    let focusPaused = false;
    let activationRequest = 0;

    const hydrateSlide = async (slide) => {
      const sources = Array.from(slide.querySelectorAll('source[data-srcset]'));
      const image = slide.querySelector('img[data-src]');
      if (!image) return;

      sources.forEach((source) => {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
      image.loading = 'eager';
      image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');

      if (image.decode) await image.decode().catch(() => {});
    };

    const showSlide = async (index) => {
      const nextIndex = (index + slides.length) % slides.length;
      const request = ++activationRequest;
      await hydrateSlide(slides[nextIndex]);
      if (request !== activationRequest) return;

      activeIndex = nextIndex;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      controls.forEach((control, controlIndex) => {
        const isActive = controlIndex === activeIndex;
        control.classList.toggle('is-active', isActive);
        if (isActive) control.setAttribute('aria-current', 'true');
        else control.removeAttribute('aria-current');
      });
    };

    const canRotate = () => !userPaused && !hoverPaused && !focusPaused && !motionQuery.matches && !compactQuery.matches && !document.hidden;
    const updateToggle = () => {
      if (!toggle) return;
      toggle.classList.toggle('is-paused', userPaused);
      toggle.setAttribute('aria-label', userPaused ? 'Start photo rotation' : 'Pause photo rotation');
      toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
    };
    const stop = () => window.clearTimeout(timer);
    const start = () => {
      stop();
      updateToggle();
      if (!canRotate() || slides.length < 2) return;
      timer = window.setTimeout(async () => {
        await showSlide(activeIndex + 1);
        start();
      }, 6000);
    };

    controls.forEach((control, index) => control.addEventListener('click', async () => {
      stop();
      await showSlide(index);
      start();
    }));
    if (toggle) toggle.addEventListener('click', () => {
      userPaused = !userPaused;
      start();
    });
    carousel.addEventListener('mouseenter', () => {
      hoverPaused = true;
      stop();
    });
    carousel.addEventListener('mouseleave', () => {
      hoverPaused = false;
      start();
    });
    carousel.addEventListener('focusin', () => {
      focusPaused = true;
      stop();
    });
    carousel.addEventListener('focusout', () => {
      focusPaused = false;
      start();
    });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    motionQuery.addEventListener('change', start);
    compactQuery.addEventListener('change', (event) => {
      if (event.matches) showSlide(0);
      start();
    });
    start();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silver-bullet-installation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 901px)');

    const syncDesktopDisclosures = (root = document) => {
      root.querySelectorAll('[data-sb-desktop-disclosure]').forEach((disclosure) => {
        if (desktopQuery.matches) {
          if (disclosure.dataset.sbDesktopDisclosureReady !== 'true') {
            disclosure.open = false;
            disclosure.dataset.sbDesktopDisclosureReady = 'true';
          }
        } else {
          disclosure.open = true;
          delete disclosure.dataset.sbDesktopDisclosureReady;
        }
      });
    };

    syncDesktopDisclosures();
    document.addEventListener('shopify:section:load', (event) => syncDesktopDisclosures(event.target));

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', () => syncDesktopDisclosures());
    } else {
      desktopQuery.addListener(() => syncDesktopDisclosures());
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silver-bullet-product-specs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('silver-bullet-selected-comparison')) {
    customElements.define(
      'silver-bullet-selected-comparison',
      class SilverBulletSelectedComparison extends HTMLElement {
        connectedCallback() {
          this.cards = Array.from(this.querySelectorAll('[data-sb-comparison-card]'));
          this.selectedBedLabel = this.closest('.silver-product-specs__comparison')?.querySelector(
            '[data-sb-selected-bed-label]'
          );
          this.productInformation = Array.from(document.querySelectorAll('product-information')).find(
            (productInformation) => productInformation.dataset.productId === this.dataset.productId
          );
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (
              this.productInformation &&
              event.data.sectionId !== this.productInformation.dataset.section
            ) {
              return;
            }

            const variantOptions = event.data.variant?.options || [];
            const selectedBedLength = variantOptions[variantOptions.length - 1];
            const selectedVariantId = event.data.variant?.id ? String(event.data.variant.id) : '';
            this.showSelectedBed(selectedBedLength, selectedVariantId);
          });
          this.showSelectedBed(this.dataset.selectedBedLength, this.dataset.selectedVariantId);
        }

        disconnectedCallback() {
          this.variantChangeUnsubscriber?.();
        }

        showSelectedBed(selectedBedLength, selectedVariantId = '') {
          if (!selectedBedLength) return;

          const selectedCard =
            this.cards.find(
              (card) => selectedVariantId && card.dataset.variantId === String(selectedVariantId)
            ) || this.cards.find((card) => card.dataset.bedLength === selectedBedLength);
          if (!selectedCard) return;

          this.cards.forEach((card) => {
            const isSelected = card === selectedCard;
            card.hidden = !isSelected;
            card.setAttribute('aria-hidden', String(!isSelected));
          });

          this.dataset.selectedBedLength = selectedBedLength;
          if (selectedVariantId) this.dataset.selectedVariantId = String(selectedVariantId);
          if (this.selectedBedLabel) this.selectedBedLabel.textContent = selectedBedLength;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
